module.exports = __webpack_public_path__ + "img/Qualification_9.8de187e1.jpg";